<template>
  <layout>
    <template v-slot:header>
      <AppHead :title="`Manage Images - ${form.sku}`" />
      <h2>Images for Product {{ form.name }}</h2>
      <BreadCrumbs activeItem="Manage Images" :crumbs="{ home: 'Dashboard', products: 'Products'}"/>
      <flash-messages />
    </template>
        
    <template v-slot:default>
      <div id="manageImages" class="mt-4">
        <ReorderImages :product="product" :images="images" :image_type="0" />
          <div class="row">
            <div class="form-group col-12 col-lg-6 px-0">
              <jet-label for="photo" value="Add Images" />
                <FileUpload 
                  mode="advanced" 
                  :auto="true" 
                  :multiple="true"
                  accept="image/*" 
                  name="images[]" 
                  :customUpload="true" 
                  :showUploadButton="true"
                  :showCancelButton="false"
                  @uploader="(event) => addImages(event, 0)" >
                  <template #empty>
                    <div class="list-file-select px-3 py-4">
                      <p class="mb-0">Drag images here.</p>
                    </div>
                  </template>
                </FileUpload>
              </div>
            </div>   
        </div>

      <h3>PDF Sheets</h3>
      <div id="managePdfs" class="mt-4">
        <ReorderImages :product="product" :images="pdfs" :image_type="3" />
          <div class="row">
            <div class="form-group col-12 col-lg-6 px-0">
              <FileUpload 
                mode="advanced" 
                :auto="true" 
                :multiple="true"
                name="pdfs[]" 
                :customUpload="true" 
                :showUploadButton="true"
                :showCancelButton="false"
                @uploader="(event) => addImages(event, 3)" >
                <template #empty>
                  <div class="list-file-select px-3 py-4">
                    <p class="mb-0">Drag pdfs here.</p>
                  </div>
                </template>
              </FileUpload>
            </div>
          </div>   
      </div>
    </template>
  </layout>
</template>

<script>

import Layout from '@/Shared/Admin/Layout'
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import FileUpload from 'primevue/fileupload';
import ReorderImages from '@/Components/Products/ReorderImages'
import BreadCrumbs from '@/Shared/BreadCrumbs'
import toastr from 'toastr'

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetCheckbox,
    JetInputError,
    JetLabel,
    Layout,
    ReorderImages,
    BreadCrumbs,
    FileUpload
  },
  props: {
    product: Object,
    images: Object,
    pdfs: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        name: this.product.name,
        sku: this.product.sku,
        photo: null,
      }),
    }
  },
  methods: {
    addImages(event, type) {
      let files = event.files;
      const formData = new FormData(); 
      formData.append("type", type);

      for (var x = 0; x < files.length; x++) {
        // append files as array to the form, feel free to change the array name
        formData.append("images[]", files[x]);
      }

      axios
        .post(route('products.addImages', this.product), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (!response.data.success) {
            toastr.error(response.data.message);
          } else {
            this.$inertia.visit(window.location.href, {preserveState: false, preserveScroll: true});
          }
        })
        .catch((err) => {
          console.error(err);
          toastr.error("Uploading or processing image failed.");
        });
    },
  }
}
</script>

<style>
  #file_select {
    border: 2px dashed #0087F7;
    border-radius: 5px;
    background: white;
    min-height: 150px;
    padding: 50px;
  }
</style>